import { WHATSAPP_CLOUD_WINDOW_MESSAGE } from '../../../supabase/functions/_shared/whatsappCloudParse';

export const WHATSAPP_DISCONNECTED_MESSAGE =
    'WhatsApp desconectado. Vá em Conexões e escaneie o QR Code novamente.';

const NO_WHATSAPP_CONNECTION = 'Nenhuma conexão WhatsApp selecionada';

/** Validação pré-envio do chat (texto, mídia, formulários especiais). */
export function getOutboundChatSendError(params: {
    hasActiveConversation: boolean;
    platform?: 'whatsapp' | 'instagram';
    hasWhatsAppInstance?: boolean;
    hasMessagingConnection?: boolean;
    officialApi?: boolean;
    whatsappLive?: 'online' | 'offline' | 'unknown' | string;
}): string | null {
    if (!params.hasActiveConversation) return 'Nenhuma conversa selecionada';

    if (params.platform === 'instagram') {
        if (!params.hasMessagingConnection) return 'Nenhuma conexão Instagram selecionada';
        return null;
    }

    if (params.officialApi) {
        if (!params.hasMessagingConnection) return NO_WHATSAPP_CONNECTION;
        if (params.whatsappLive === 'offline') {
            return 'WhatsApp oficial desconectado. Conecte de novo em Canais de atendimento.';
        }
        return null;
    }

    if (!params.hasWhatsAppInstance) return NO_WHATSAPP_CONNECTION;
    if (params.whatsappLive === 'offline') return WHATSAPP_DISCONNECTED_MESSAGE;
    return null;
}

const REPLY_WINDOW_MS = 24 * 60 * 60 * 1000;

export const INSTAGRAM_REPLY_WINDOW_MESSAGE =
    'Fora da janela de 24h do Instagram. O contato precisa enviar uma nova mensagem primeiro.';

/**
 * @param historyReady — true quando o histórico já pode ser avaliado.
 *   IG: pass `!isLoadingMessages` (histórico vazio após o fetch ainda bloqueia).
 *   WA Cloud: pass `messages.length > 0` (comportamento legado intacto).
 */
function replyWindowError(
    lastInboundAt: number | null,
    historyReady: boolean,
    message: string,
): string | null {
    if (!historyReady) return null;
    if (lastInboundAt == null || Date.now() - lastInboundAt > REPLY_WINDOW_MS) return message;
    return null;
}

/** Instagram só aceita resposta até 24h depois da última mensagem do contato. */
export function getInstagramReplyWindowError(
    lastInboundAt: number | null,
    historyReady: boolean,
): string | null {
    return replyWindowError(lastInboundAt, historyReady, INSTAGRAM_REPLY_WINDOW_MESSAGE);
}

/** Cloud API só aceita texto livre até 24h depois da última mensagem do contato. */
export function getWhatsappCloudReplyWindowError(
    lastInboundAt: number | null,
    historyReady: boolean,
): string | null {
    return replyWindowError(lastInboundAt, historyReady, WHATSAPP_CLOUD_WINDOW_MESSAGE);
}
